import React from 'react';
import {
    Container,
    Button,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Typography,
    Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
    },
    addButton: {
        marginBottom: theme.spacing(2),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
    },
    tableHeaderCell: {
        textAlign: 'center !important',
        fontSize: '17px',
        fontWeight: 500,
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px !important',
        },
    },
}));

const FrameWorksList = ({data, options,actions}) => {
    const classes = useStyles();

    return (
        <Container className={classes.container} maxWidth={false}>
            <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 2, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                Your Frameworks
            </Typography>
            <Box display={'flex'} justifyContent="flex-end" alignItems="center"  mb={2}>
                <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                    className={classes.addButton}
                >
                    ADD ANOTHER FRAMEWORK
                </Button>
            </Box>
            {/* Table */}
            <TableContainer component={Paper}>
                <Table aria-label="programs table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell}>Framework ID</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Framework Title</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Submission Date</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={6} align="center">
                                No FrameWorks found.
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
};

export default FrameWorksList;
